import * as React from "react"
import { Header } from "../../components/Header/Header";

import { ViolationsHistoryInner } from "./ViolationsHistoryInner"

export default class ViolationsHistory extends React.Component {

    render() {

        return (<div>
                    <Header />
                    <ViolationsHistoryInner />
                </div>)
    }
}


// WEBPACK FOOTER //
// ./src/Routes/ViolationsHistory/ViolationsHistory.tsx